import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getToken, removeToken } from "./cookies";

const ProtectedRoute = ({ children }) => {
  const token = getToken();
  const { isAuthenticated } = useSelector((state) => state.auth);
  
  console.log("🔐 ProtectedRoute - Token:", token);
  console.log("🔐 ProtectedRoute - isAuthenticated:", isAuthenticated);

  // ✅ Check if token exists
  if (!token) {
    console.log("❌ No token found, redirecting to login");
    return <Navigate to="/login" replace />;
  }

  // ✅ Validate token expiry
  try {
    const decoded = JSON.parse(atob(token.split(".")[1]));
    const isExpired = decoded.exp * 1000 < Date.now();
    
    if (isExpired) {
      console.log("❌ Token expired, redirecting to login");
      removeToken();
      return <Navigate to="/login" replace />;
    }
    
    console.log("✅ Token valid, rendering children");
    return children;
    
  } catch (err) {
    console.log("❌ Invalid token, redirecting to login", err);
    removeToken();
    return <Navigate to="/login" replace />;
  }
};

export default ProtectedRoute;